<template>
  <div class="qty-component d-flex justify-content-around">
    <button class="rmv-qty-btn text-white" @click="updateQuantity(-1)">
      <font-awesome-icon icon="fa-solid fa-minus"/>
    </button>
    <input class="qty-input" v-model="saleLine.Qty" @input="recalculateLine" type="number" :readonly="isReadOnly" min="1"/>
    <button class="add-qty-btn text-white" @click="updateQuantity(1)">
      <font-awesome-icon icon="fa-solid fa-plus"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "CurrentSaleQty",
  props: {
    saleLine: {
      type: Object,
      required: true
    },
    saleNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    deviceSettings() {
      return this.$store.getters.getDeviceSettings;
    },
    isReadOnly() {
      if (!this.deviceSettings) return true;
      return !this.deviceSettings.SelectQty || (this.saleLine.instructions && this.saleLine.instructions.length > 0);
    },
  },
  methods: {
    // Helper function to update quantity and recalculate line total
    async updateQuantity(change) {
      const newQty = this.saleLine.Qty + change;
      if (this.saleLine.savedQty === undefined) {
        this.saleLine.savedQty = this.saleLine.Qty;
      }
      console.log("savedQty:", this.saleLine.savedQty);
      const initialQty = Number(this.saleLine.savedQty);

      if (newQty > 0) {
        if (change === -1) {
          // Check if we're reducing below the initial quantity
          if (!isNaN(initialQty) && newQty < initialQty) {
            // Need security validation before reducing quantity
           
            if (!this.saleLine.instructions) this.saleLine.instructions = [];

            // Set override details for the void operation
            await this.$store.commit(`setOverrideDetails`, `Void Line (${this.saleLine.Description})`);

            // Call voidItemTable which will handle security validation
            // Only update quantity if validation succeeds
            try {
              await this.$store.commit('voidItemTable', this.saleLine);
              // Only update quantity after successful validation
              this.saleLine.Qty = newQty;
              // Mark that void was already processed to prevent duplicate calls
              this.saleLine._voidProcessed = true;
            } catch (error) {
              console.error("Error voiding item:", error);
              // Don't update quantity if validation fails
              return;
            }
          } else {
            // Not reducing below initial quantity, just update
            this.saleLine.Qty = newQty;
          }
        } else {
          // For incrementing, just update Qty
          this.saleLine.Qty = newQty;
        }

        return this.recalculateLine(); // Recalculate the line total
      }

      return Swal.fire({
        title: 'To void open the table',
        text: "This step cannot be reversed!",
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
      })
    },


    // Recalculate the Line total whenever the quantity is updated
    async recalculateLine() {
      // If user typed a quantity lower than initial, handle voiding
      const currentQty = Number(this.saleLine.Qty)
      // If savedQty is undefined, use current Qty as fallback
      // This ensures consistent behavior with updateQuantity method
      // and handles cases where items haven't been properly initialized
      if (this.saleLine.savedQty === undefined) {
        this.saleLine.savedQty = this.saleLine.Qty;
      }
      const initialQty = Number(this.saleLine.savedQty)

      if (!isNaN(initialQty) && currentQty < initialQty) {
        // Check if void was already processed by updateQuantity method
        if (this.saleLine._voidProcessed) {
          // Clear the flag and skip void processing since it was already done
          delete this.saleLine._voidProcessed;
        } else {
          // Prevent direct quantity reduction below initial without security validation
          // Ensure current sale lines are loaded
         

          // Set override details for the void operation
          await this.$store.commit(`setOverrideDetails`, `Void Line (${this.saleLine.Description})`)

          // Call voidItemTable which will handle security validation
          try {
            // Use voidItemTable for consistency with updateQuantity method
            await this.$store.commit('voidItemTable', this.saleLine);

            // If validation succeeds, allow the quantity change
            // No need to update Qty here as it's already been set by v-model
          } catch (error) {
            console.error("Error voiding item:", error);
            // If validation fails, revert to initial quantity
            this.saleLine.Qty = initialQty;
            return;
          }
        }
      }

      // Update line total
      this.saleLine.Line = this.saleLine.Unit * this.saleLine.Qty;
      this.recalculateTip();
      this.$emit('update-saleLine', this.saleLine);
    },

    recalculateTip() {
      return this.$store.dispatch('calculateTipAmount');
    },

    askForPrice(item) {
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${item.Unit.toFixed(2)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`);
          }
          return parseFloat(value);
        }
      }).then(result => {
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2));
      });
    },
  }
}
</script>

<style scoped>
.qty-component {
  gap: 5px;
}

.qty-input {
  width: 50px;
  border: 1px solid #C9CACF;
  border-radius: 10px;
  text-align: center;
}

.add-qty-btn, .rmv-qty-btn {
  border-radius: 10px;
  width: 30px;
  height: 30px;
}

button {
  background: #0092f7;
}
</style>
